import VehicleActions from './actions';

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: {}
};

function VehicleReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
  case VehicleActions.NEW_DATA:
    return { ...state, isProcessing: true,  isError: false};
  case VehicleActions.SHOW_DATA:
    return { ...state, isProcessing: false, isAuthenticated: true, isError: false, data: action.payload, errorMessage: {} };
  default:
    return state;
  }
}

export default VehicleReducer;
